import qs from "qs";
import CanvasDrawer from "./CanvasDrawers";

import { connect } from "react-redux";
import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import withState from "recompose/withState";
import withProps from "recompose/withProps";
import lifecycle from "recompose/lifecycle";

import withQueryParams from "../../hocs/withQueryParams";
import withCart from "../../hocs/withCart";
import withProduct from "../../hocs/withProduct";
import withCountry from "../../hocs/withCountry";

import createFeatureFlagFactory from "../../utils/feature-flag-factory";
import buildProductUrl from "../../utils/buildProductUrl";
import { getActiveCanvasDrawer, updateActiveCanvasDrawer } from "./duck";
import { trackSaveCanvasChanges } from "../../../analytics/category/cart";
import { getItems } from "../../../store/selectors/cart";
import { updateOrderItem } from "../../../facades/eagle/user";
import { addFlashMessageError } from "../FlashMessages/duck";

import {
  shouldRedirectToOptions,
  buildOrderUrl,
  flagUneditableDrawer,
  openNextAvailableDrawer,
} from "./helpers";
import { localiseUrlII } from "../../../../../common/utils/format-localised-url";

const featureFlagGuidedCanvasDrawers = createFeatureFlagFactory(
  "guided_canvas_drawers"
);

const enhance = compose(
  withQueryParams,
  withState("showCanvasPrompt", "setShowCanvasPrompt", false),
  connect(
    (state) => ({
      activeDrawer: getActiveCanvasDrawer(state),
      cartItems: getItems(state),
    }),
    (dispatch) => ({
      setActiveDrawer: (key) => dispatch(updateActiveCanvasDrawer(key)),
      flashError: (error) => dispatch(addFlashMessageError(error)),
    })
  ),
  withCart,
  withProps((props) => {
    // This is the slug we send with save for later.  The social title is the proper name for the email
    const productName =
      props.model?.prismicPageModel?.social?.title?.split("|")[0] ||
      props.productId;

    /* eslint-disable eqeqeq */
    // Check whether the value in the url query params matches the id of an actual cart item
    // this is to avoid hiding drawers if the id is faked (from the url params for example)
    const isCartItem = props.cartItems.some(
      (item) => item.id == props.match.params.itemId
    );
    /* eslint-enable eqeqeq */
    return {
      isCartItem,
      drawers: flagUneditableDrawer(
        isCartItem,
        !!props.match.params.itemId,
        props.drawers
      ),
      cartPending: props.cart.status.request.queue.length > 0,
      isAllDrawersComplete: props.completedDrawersMap.required.every((drawer) =>
        props.completedDrawersMap.complete.includes(drawer)
      ),
      productName: productName,
    };
  }),
  withProduct,
  withCountry,
  withHandlers({
    onSubmitDrawers: (props) => () => {
      const itemId = props.match.params.itemId;
      const orderNumber = props.match.params.orderNumber;
      const countryModel = props.model.countryModel;
      const browserQuery = props.history.location.search;

      if (itemId && orderNumber) {
        const payload = {
          item: { id: itemId, customisations: props.productCustomisation },
        };
        // Editing a post-purchase item
        updateOrderItem(payload)
          .then((res) => {
            window.location = res.headers.admin_redirect_url
              ? res.headers.admin_redirect_url
              : buildOrderUrl(props);
          })
          .catch((err) => {
            const errors = err.details.errors;
            errors.forEach((error) => props.flashError(error.detail));
          });
      } else if (itemId) {
        // Mirroring the PDC books behaviour, when editing an item in the cart, redirect straight to cart
        shouldRedirectToOptions(props).then(async () => {
          const sku = props.product.id;
          trackSaveCanvasChanges(sku);
          await props.cart.edit(itemId);
          window.location = buildProductUrl(props, { type: "cart" });
        });
      } else {
        const destination = props.prismicProduct.formats.enabled
          ? "formats"
          : "giftwraps";
        const nextPageUrl = `/personalized-products/${props.product.slug}/create/${destination}`;
        const search = qs.stringify(
          {
            ...qs.parse(browserQuery, { ignoreQueryPrefix: true }),
            ...props.queryParams,
            muse_slug_override: props.product.museSlug,
          },
          { addQueryPrefix: true }
        );

        // Or redirect to PDC routes
        window.location = localiseUrlII(
          countryModel,
          `/${nextPageUrl}${search}`
        );
      }
    },
    handleOpenNextAvailableDrawer: (props) => () =>
      openNextAvailableDrawer(props),
    handleToggleDrawer: (props) => (key) => {
      props.setActiveDrawer(key);
      if (featureFlagGuidedCanvasDrawers.enabled && !key) {
        openNextAvailableDrawer(props);
      }
    },
    handleCancelDrawer: (props) => () => {
      props.setActiveDrawer();
    },
  }),
  lifecycle({
    componentDidMount() {
      if (featureFlagGuidedCanvasDrawers.enabled) {
        openNextAvailableDrawer(this.props);
      }
    },
  })
);

export default enhance(CanvasDrawer);
